import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { rolesDaUrl } from '../layout/component/app.menu.itens';
import { LoginService } from '../services/login.service';
import { PermissionService } from '../services/permission.service';
import { TipoUsuario } from '../types/LoginResponse.type';

export const authGuard: CanActivateFn = (route, state) => {
    const login = inject(LoginService);
    const router = inject(Router);
    if (!login.isAutenticado()) return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
    const tipos = route.data['tipos'] as TipoUsuario[] | undefined;
    if (tipos?.length && (!login.getTipo() || !tipos.includes(login.getTipo()!))) return router.createUrlTree(['/auth/access']);
    const roles = route.data['roles'] as string[] | undefined;
    if (roles?.length && !roles.some(role => inject(PermissionService).hasPermission(role))) return router.createUrlTree(['/auth/access']);
    return true;
};

/**
 * Bloqueia o acesso direto pela URL às telas do menu que os perfis do usuário não liberam.
 * O admin do sistema acessa todas; URLs fora do menu seguem as regras da própria rota.
 */
export const menuGuard: CanActivateChildFn = (route, state) => {
    const login = inject(LoginService);
    if (login.getTipo() === 'ADMIN_SISTEMA') return true;
    const roles = rolesDaUrl(state.url);
    if (!roles) return true;
    const permissoes = inject(PermissionService);
    return roles.some(role => permissoes.hasPermission(role)) || inject(Router).createUrlTree(['/auth/access']);
};
